import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonPhoneDTOBase } from "./PersonPhoneDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { PhoneStaff } from "./PhoneStaff";

export class PersonPhoneStaff implements PersonPhoneDTOBase {
  constructor(public readonly assignId: number, public readonly name: string | null, public readonly personId: PersonStaff | null, public readonly phoneId: PhoneStaff) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonPhoneStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
